export const Action = {
  Left: "left",
  Right: "right",
  Jump: "jump",
  Confirm: "confirm",
  Cancel: "cancel",
} as const;

export type Action = (typeof Action)[keyof typeof Action];

export type ActionState = Record<Action, boolean>;

export function createEmptyActionState(): ActionState {
  return {
    left: false,
    right: false,
    jump: false,
    confirm: false,
    cancel: false,
  };
}
